function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13082_313380)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.6668 6.66602H20.0002C16.3335 6.66602 13.3668 9.66602 13.3668 13.3327L13.3335 66.666C13.3335 70.3327 16.3002 73.3327 19.9668 73.3327H60.0002C63.6668 73.3327 66.6668 70.3327 66.6668 66.666V26.666L46.6668 6.66602ZM60.0002 66.666H20.0002V13.3327H43.3335V29.9993H60.0002V66.666ZM26.6668 50.0327L31.3668 54.7327L36.6668 49.466V63.3327H43.3335V49.466L48.6335 54.766L53.3335 50.0327L40.0335 36.666L26.6668 50.0327Z",
  fill: "#121212"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13082_313380"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  fill: "white"
})));

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.bc2cb960.svg";
export { ForwardRef as ReactComponent };